const containerId = 'evaluate-toaster-container';
const doc = window.document;
const body = doc.body;
let $container = body.querySelector(`#${containerId}`);
if (!$container) { // 不存在
  let c = doc.createElement('div');
  c.className = 'toaster-container';
  c.id = containerId;
  c.style.height = 0;
  body.appendChild(c);
  $container = c;
}
const cache = {
  'index': 9999,
  'eles': {}
};

function _close(id) {
  let node = cache.eles[id]
  if (node) {
    node.remove()
  }
}

function talert(msg) {
  let c = doc.createElement('div');
  let index = (cache.index++);
  c.id = `alert-${index}`;
  c.style.zIndex = index;
  c.className = 'alert';
  c.innerHTML = `<div class="content">${msg}<div>`;
  let ae = doc.createElement('div')
  ae.className = 'actions'
  let postiveBtn = doc.createElement('button')
  postiveBtn.className = 'btn btn-default btn-sm'
  postiveBtn.innerText = '确定'
  postiveBtn.onclick = function () {
    _close(index)
  }
  ae.appendChild(postiveBtn)
  c.appendChild(ae)
  $container.appendChild(c)
  cache.eles[index] = c
}
export default {
  alert: talert
}



// WEBPACK FOOTER //
// ./src/plugins/toaster.js